module.exports = __webpack_public_path__ + "2a84e8861b2c1a114c058794748b45fe.svg";